import styled from "styled-components";

export const ContainerResumenLista = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 20px;

  /* Centrado para tablet y desktop */
  @media (min-width: 768px) {
    align-items: center; /* centra horizontalmente los items */
    padding-left: 0; /* quitamos desplazamiento a la izquierda */
  }
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  margin-top: 14px;
  gap: 18px;
  width: ${({ $isTerminal }) => ($isTerminal ? "400px" : "320px")};
`;
